// extracted by mini-css-extract-plugin
export default {"content":"PrivacyPolicyPage_content__sEpGq"};